import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';

const API = process.env.REACT_APP_BACKEND_URL;

const WEEKDAYS = [
  { key: 'monday', label: 'Montag' },
  { key: 'tuesday', label: 'Dienstag' },
  { key: 'wednesday', label: 'Mittwoch' },
  { key: 'thursday', label: 'Donnerstag' },
  { key: 'friday', label: 'Freitag' },
  { key: 'saturday', label: 'Samstag' },
  { key: 'sunday', label: 'Sonntag' },
];

const TARGET_DAYS = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag'];

export default function AdminAppointmentDays() {
  const [settings, setSettings] = useState({
    monday: 'Montag',
    tuesday: 'Montag',
    wednesday: 'Montag',
    thursday: 'Montag',
    friday: 'Dienstag',
    saturday: 'Dienstag',
    sunday: 'Dienstag',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const token = localStorage.getItem('admin_token');
      const response = await axios.get(`${API}/api/admin/appointment-day-settings`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
      toast.error('Fehler beim Laden der Einstellungen');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (day, value) => {
    setSettings(prev => ({ ...prev, [day]: value }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const token = localStorage.getItem('admin_token');
      await axios.put(`${API}/api/admin/appointment-day-settings`, settings, {
        headers: { Authorization: `Bearer ${token}` }
      });
      toast.success('Einstellungen gespeichert!');
    } catch (error) {
      console.error('Error saving settings:', error);
      toast.error('Fehler beim Speichern');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6" data-testid="appointment-days-settings">
      <div>
        <h1 className="text-2xl font-bold text-slate-800">Termin-Tage Einstellungen</h1>
        <p className="text-slate-600 mt-1">
          Lege fest, an welchem Tag ein Termin angeboten wird, abhängig davon wann der Bewerber chattet.
        </p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="p-6">
          <div className="grid gap-4">
            <div className="grid grid-cols-2 gap-4 pb-3 border-b border-slate-200 font-semibold text-slate-700">
              <div>Bewerber chattet am...</div>
              <div>Termin für...</div>
            </div>
            
            {WEEKDAYS.map(({ key, label }) => (
              <div key={key} className="grid grid-cols-2 gap-4 items-center py-2">
                <div className="font-medium text-slate-700">{label}</div>
                <select
                  value={settings[key]}
                  onChange={(e) => handleChange(key, e.target.value)}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 bg-white"
                  data-testid={`select-${key}`}
                >
                  {TARGET_DAYS.map(day => (
                    <option key={day} value={day}>{day}</option>
                  ))}
                </select>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-slate-50 px-6 py-4 border-t border-slate-200">
          <div className="flex items-center justify-between">
            <p className="text-sm text-slate-500">
              Termine sind immer um <strong>13:00 Uhr</strong> in der Folgewoche.
            </p>
            <button
              onClick={handleSave}
              disabled={saving}
              className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              data-testid="save-button"
            >
              {saving ? 'Speichern...' : 'Speichern'}
            </button>
          </div>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-xl p-4">
        <h3 className="font-semibold text-blue-800 mb-2">Beispiel</h3>
        <p className="text-blue-700 text-sm">
          Wenn ein Bewerber am <strong>Freitag</strong> chattet und du <strong>Dienstag</strong> eingestellt hast,
          bekommt er einen Termin für den <strong>nächsten Dienstag</strong> um 13:00 Uhr.
        </p>
      </div>
    </div>
  );
}
